module.exports = __webpack_public_path__ + "static/bg-9f5122bfdb1dbe44cec288db5be43ee7.jpg";